import { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faFilePdf, faBars, faXmark } from '@fortawesome/free-solid-svg-icons'
import './index.scss'

const NavBar = () => {
  const [showNav, setShowNav] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const close = () => setShowNav(false)

  return (
    <header className={`top-nav${scrolled ? ' scrolled' : ''}`}>
      <a href="#home" className="text-logo" onClick={close}>
        Akshata Dhuraji
      </a>

      <button
        className="hamburger-btn"
        onClick={() => setShowNav(true)}
        aria-label="Open menu"
      >
        <FontAwesomeIcon icon={faBars} />
      </button>

      {showNav && <div className="nav-overlay" onClick={close} />}

      <nav className={showNav ? 'mobile-show' : ''}>
        <button className="close-btn" onClick={close} aria-label="Close menu">
          <FontAwesomeIcon icon={faXmark} />
        </button>

        <a href="#home" onClick={close}>Home</a>
        <a href="#about" onClick={close}>About</a>
        <a href="#portfolio" onClick={close}>Projects</a>
        <a href="#contact" onClick={close}>Contact</a>
      </nav>

      <div className="social-icons">
        <a href="mailto:akshata.dhuraji@gmail.com" title="Email">
          <FontAwesomeIcon icon={faEnvelope} />
        </a>
        <a
          href="https://www.linkedin.com/in/akshatadhuraji/"
          target="_blank"
          rel="noreferrer"
          title="LinkedIn"
        >
          <FontAwesomeIcon icon={faLinkedin} />
        </a>
        <a
          href="https://github.com/akshataxx"
          target="_blank"
          rel="noreferrer"
          title="GitHub"
        >
          <FontAwesomeIcon icon={faGithub} />
        </a>
        <a
          href="https://drive.google.com/file/d/1M6eJjwp2NDNYGi39-YJtho1DNAcWlEtc/view?usp=sharing"
          target="_blank"
          rel="noreferrer"
          title="Resume"
        >
          <FontAwesomeIcon icon={faFilePdf} />
        </a>
      </div>
    </header>
  )
}

export default NavBar
